var exports = {
  "ZH": "GuildBadge.module__badgeWrapper___VVFscE",
  "qS": "GuildBadge.module__badge___VVFscE",
  "eT": "GuildBadge.module__badgeOnLightSurface___VVFscE",
  "YW": "GuildBadge.module__badgeBanner___VVFscE",
  "e$": "GuildBadge.module__badgeBannerDark___VVFscE",
};

module.exports = exports;
